// Filename: models/questionnaire/question.js
define('models/questionnaire/question',[
    // libs
    'underscore', 'backbone', 'moment',
    // services
    'utils',
    'services/api',
    // collections
    'collections/questionnaire/options/options'
], function(
    // libs
    _, Backbone, moment, U,
    // services
    API,
    // collections
    COptions
) {

    var MQuestion = Backbone.Model.extend({
        idAttribute: 'id',

        defaults: {
            name: "",
            type: "text",
            lock: false,
            deleted: false,
        },

        getName: function() {
            return this.get('name');
        },

        getAnswer: function() {
            return this.get('answer');
        },

        getType: function() {
            return this.get('type');
        },

        getOptions: function() {
            return new COptions(this.get('options'));
        },

        updatePosition: function(position, options) {
            options = options || {};
            this.set({ id: position }, options);
        },

        hasOptions: function() {
            return this.has('options');
        },

        isOptionsEnabled: function() {
            return _.contains(this.getTypeWithOptions(), this.get('type'));
        },

        getTypeWithOptions: function() {
            return MQuestion.TYPE_WITH_OPTIONS;
        },

        getDefaultAnswer: function() {
            return MQuestion.DEFAULT_ANSWER_BY_TYPE[this.getType()];
        },

        getTypes: function() {
            return MQuestion.TYPES;
        },

        ////////////////
        // validation //
        ////////////////
        validation: {
            type: {
                presence: true
            },
            name: {
                presence: true
            }
        }
    }, {
        ///////////////////////
        // static properties //
        ///////////////////////
        TYPES: [
            { name: 'questionnaire:questionnaire-short-answer', value: 'text' },
            { name: 'questionnaire:questionnaire-long-answer', value: 'textarea' },
            { name: 'questionnaire:questionnaire-number', value: 'number' },
            { name: 'Date', value: 'date' },
            { name: 'questionnaire:questionnaire-checkbox', value: 'checkbox' },
            { name: 'questionnaire:questionnaire-radio-buttons', value: 'radio' },
            { name: 'questionnaire:questionnaire-dropdown-menu', value: 'select' },
        ],
        DEFAULT_ANSWER_BY_TYPE: {
            checkbox: [],
            radio: "",
            select: "",
            text: "",
            textarea: "",
            number: "",
            date: API.formatDate(moment()),
        },
        TYPE_WITH_OPTIONS: ['select', 'radio', 'checkbox']
    });

    // Return the model for the module
    return MQuestion;
});

